import { Client, ConnectionState } from "@twilio/conversations";

class TwilioClientConnectionError extends Error {
  constructor(client?: Client | null, status?: ConnectionState) {
    super(`Twilio Client is not connected. Status: ${client?.connectionState ?? status ?? "unknown"}`);
  }
}

export default TwilioClientConnectionError;
